import { createFileRoute } from '@tanstack/react-router';
import { SharingPage } from '../../features/rates';

export const Route = createFileRoute('/portal/rates/sharing')({ component: SharingPage });
